import { render, staticRenderFns } from "./role.vue?vue&type=template&id=65129f50&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./role.vue?vue&type=style&index=1&id=65129f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65129f50",
  null
  
)

export default component.exports